import React from 'react';
import './CheckDetailModal.css';

const CheckDetailModal = ({ isVisible, checkDetails, onClose }) => {
    if (!isVisible) {return null;}

    const checkSummary = checkDetails.length > 0 ? checkDetails[0] : {};
    return (
        <div className="check-detail-modal-overlay">
            <div className="check-detail-modal">
                <div className="modal-header">
                    <h3>Детали чека</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    {checkDetails.length === 0 ? (
                        <p>Загрузка...</p>
                    ) : (
                        <>
                            <div className="check-summary">
                                <h4>Общие данные о чеке</h4>
                                <div className="check-detail-row">
                                    <span className="label">Дата покупки:</span>
                                    <span>{checkSummary.d_time}</span>
                                </div>
                                <div className="check-detail-row">
                                    <span className="label">Сумма:</span>
                                    <span>{checkSummary.n_amount_check} ₽</span>
                                </div>
                                <div className="check-detail-row">
                                    <span className="label">Сумма до скидки:</span>
                                    <span>{checkSummary.n_amount_full} ₽</span>
                                </div>
                                <div className="check-detail-row">
                                    <span className="label">Бонусы добавлены:</span>
                                    <span
                                        style={{ color: checkSummary.bonus_add > 0 ? 'green' : 'green' }}>
                                        {checkSummary.bonus_add === '.00'
                                            ? '0 ₽'
                                            : checkSummary.bonus_add > 0
                                                ? `+${checkSummary.bonus_add} ₽`
                                                : `${checkSummary.bonus_add} ₽`}
                                    </span>
                                </div>
                                <div className="check-detail-row">
                                    <span className="label">Бонусы списаны:</span>
                                    <span style={{ color: checkSummary.bonus_sub > 0 ? 'red' : 'red' }}>
                                        {checkSummary.bonus_sub === '.00'
                                            ? '0 ₽'
                                            : checkSummary.bonus_sub > 0
                                                ? `-${checkSummary.bonus_sub} ₽`
                                                : `${checkSummary.bonus_sub} ₽`}
                                    </span>
                                </div>
                                <div className="check-detail-row">
                                    <span className="label">Торговая точка:</span>
                                    <span>{checkSummary.s_name}</span>
                                </div>
                            </div>
                            <div className="check-detail-items-container">
                                {checkDetails.map((item, index) => (
                                    <div key={index} className="check-detail-item">
                                        <div className="check-detail-row">
                                            <span className="label">Товар:</span>
                                            <span>{item.s_goods}</span>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="label">Кол-во:</span>
                                            <span>{item.n_quantity}</span>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="label">Сумма:</span>
                                            <span>{item.n_amount === '.00' ? '0' : item.n_amount} ₽</span>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="label">Скидка:</span>
                                            <span>{item.n_discount === '.00' ? '0' : item.n_discount} ₽</span>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="label">Бонусы:</span>
                                            <span>
                                                <span
                                                    style={{ color: item.n_bonus === '.00' ? 'green' : 'green' }}>
                                                    {item.n_bonus === '.00' ? '0' : `+${item.n_bonus}`}
                                                </span>
                                                {' / '}
                                                <span
                                                    style={{ color: item.n_paybonus === '0.00' ? 'red' : 'red' }}>
                                                    {item.n_paybonus === '.00' ? '0' : `-${item.n_paybonus}`}
                                                </span>
                                            </span>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="label">Акция:</span>
                                            <span>{item.s_actions}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CheckDetailModal;
